{
  "commentForm": {
    "placeholder": "Adicionar um comentário"
  },
  "commentList": {
    "title": "Todos os comentários"
  },
  "viewAllComments": "Exibir todos os comentários",
  "edited": "Editado",
  "comment": "Comentário",
  "comments": "Comentários",
  "moveComments": "Mova os comentários aqui",
  "showComments": "Mostrar comentários",
  "hideComments": "Ocultar comentários",
  "justNow": "Agora mesmo",
  "deleteConfirmation": {
    "title": "Excluir comentário",
    "description": "Tem certeza de que deseja excluir este comentário? Essa ação não pode ser revertida."
  },
  "addComment": "Adicionar comentário",
  "cancelComment": "Cancelar adição de comentário"
}